module.exports = {
    "queryImageInfo": "/api/cps/queryImageInfo", // 镜像详情
};



// WEBPACK FOOTER //
// ./src/api/mirror/detail/config.js